import { render, staticRenderFns } from "./MemoTable.vue?vue&type=template&id=cbb921be&scoped=true&lang=pug&"
import script from "./MemoTable.vue?vue&type=script&lang=js&"
export * from "./MemoTable.vue?vue&type=script&lang=js&"
import style0 from "./MemoTable.vue?vue&type=style&index=0&id=cbb921be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb921be",
  null
  
)

export default component.exports